module.exports = __webpack_public_path__ + "static/media/ar-icon.37a37793.svg";